import {
  differenceInMilliseconds,
  format as formatDate,
  formatDuration as baseFormatDuration,
  formatISO,
  intervalToDuration,
  isValid,
  parseISO,
} from "date-fns";

export function formatISODate(date: Date): string;
export function formatISODate(
  date: string | Date | null | undefined,
): string | undefined;
export function formatISODate(
  date: string | Date | null | undefined,
): string | undefined {
  if (!date) return;

  if (typeof date === "string") {
    return formatISODate(parseISO(date));
  }

  if (!isValid(date)) return;

  return formatISO(date, { representation: "date" });
}

export function makeFormatDate(format: string) {
  return (date: string | Date | null | undefined): string | undefined => {
    if (!date) return;

    if (typeof date === "string") {
      return makeFormatDate(format)(parseISO(date));
    }

    if (!isValid(date)) return;

    return formatDate(date, format);
  };
}

export const formatFullDate = makeFormatDate("PPP");
export const formatFullDateTime = makeFormatDate("PPPp");

export function formatDurationMs(
  durationMs: number | null | undefined,
): string | undefined {
  if (durationMs === null || durationMs === undefined) return;

  const absoluteDurationMs = Math.abs(durationMs);

  if (absoluteDurationMs < 1000) return `${absoluteDurationMs} ms`;

  return baseFormatDuration(
    intervalToDuration({
      start: new Date(0),
      end: new Date(absoluteDurationMs),
    }),
    { delimiter: ", " },
  );
}

export function formatDuration(
  startTime: string | Date | null | undefined,
  endTime: string | Date | null | undefined,
): string | undefined {
  if (!startTime || !endTime) return;

  const start = typeof startTime === "string" ? parseISO(startTime) : startTime;
  const end = typeof endTime === "string" ? parseISO(endTime) : endTime;

  if (!isValid(start) || !isValid(end)) return;

  const duration = intervalToDuration({ start, end });

  if (Math.abs(differenceInMilliseconds(end, start)) < 1000) {
    return baseFormatDuration(duration, {
      format: ["seconds"],
      zero: true,
    });
  }

  return baseFormatDuration(duration, { delimiter: ", " });
}
